import React, { createContext, useContext, useId } from 'react';

interface FieldContextValue {
  inputId: string;
  errorId: string;
  hintId: string;
  hasError: boolean;
  hasHint: boolean;
}

const FieldContext = createContext<FieldContextValue | null>(null);

export function useFieldContext() {
  return useContext(FieldContext);
}

interface FormFieldProps {
  label: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FormField({ label, error, hint, required, children }: FormFieldProps) {
  const baseId = useId();
  const value: FieldContextValue = {
    inputId: `${baseId}-input`,
    errorId: `${baseId}-error`,
    hintId: `${baseId}-hint`,
    hasError: Boolean(error),
    hasHint: Boolean(hint),
  };

  return (
    <FieldContext.Provider value={value}>
      <div className="flex flex-col gap-1">
        <label htmlFor={value.inputId} className="text-sm font-medium text-text-medium">
          {label}
          {required && (
            <span className="text-danger ml-0.5" aria-hidden="true">
              *
            </span>
          )}
        </label>
        {children}
        {hint && (
          <span id={value.hintId} className="text-sm text-text-medium">
            {hint}
          </span>
        )}
        {error && (
          <span id={value.errorId} className="text-danger text-sm">
            {error}
          </span>
        )}
      </div>
    </FieldContext.Provider>
  );
}
